import React, { useState, useEffect } from 'react';
import styles from './App.module.css';
import "./styles/reset.css"
import "./styles/global.css"

import { SearchBar } from './components/SearchBar';
import { ProductCard } from './components/ProductCard';
import { TestTube } from 'lucide-react';
import { searchProducts } from './services/searchService';
import {
  getAllFunctions,
  getAllGroups,
  filterProducts
} from './services/filterService';

import { colors } from './styles/colors';


export function App() {
  // const [searchResults, setSearchResults] = useState([]);
  const [favorites, setFavorites] = useState(() => {
    const saved = localStorage.getItem('favorites');
    return saved ? JSON.parse(saved) : [];
  });
  const [loading, setLoading] = useState(false);
  const [selectedFunction, setSelectedFunction] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [availableGroups, setAvailableGroups] = useState([]);
  const [availableFunctions, setAvailableFunctions] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);

  useEffect(() => {
    localStorage.setItem('favorites', JSON.stringify(favorites));
  }, [favorites]);

  useEffect(() => {
    async function loadFiltersAndProducts() {
      const groups = await getAllGroups();
      const functions = await getAllFunctions();
      setAvailableGroups(groups);
      setAvailableFunctions(functions);

      const initialProducts = await filterProducts(selectedFunction, selectedGroup);
      setFilteredResults(initialProducts);
    }
    loadFiltersAndProducts();
  }, []);

  const handleSearch = async (query) => {
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      let results;
      if (!query.trim()) {
        // “Query” vazio: recarrega todos os produtos de acordo com os filtros
        results = await filterProducts(selectedFunction, selectedGroup);
      } else {
        results = await searchProducts(query);
      }
      setFilteredResults(results);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = async (type, value) => {
    if (type === 'function') {
      setSelectedFunction(value);
    } else {
      setSelectedGroup(value);
    }

    const newResults = await filterProducts(
      type === 'function' ? value : selectedFunction,
      type === 'group' ? value : selectedGroup
    );

    setFilteredResults(newResults);
  };

  const toggleFavorite = (product) => {
    setFavorites(prev => {
      const isFavorite = prev.some(p => p.name === product.name);
      if (isFavorite) {
        return prev.filter(p => p.name !== product.name);
      } else {
        return [...prev, product];
      }
    });
  };

  return (
    <div className={styles.container}>
      <header
        className={styles.header}
        style={{ background: colors.primary.blue }}
      >
        <div className={styles.headerContent}>
          <div className={styles.headerFlex}>
            <TestTube className={styles.icon} size={36} />
            <div>
              <h1 className={styles.title}>
                BASF Solutions Hub
              </h1>
              <p className={styles.subtitle}>
                Encuentra los productos perfectos para tu formulación
              </p>
            </div>
          </div>
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.searchContainer}>
          <SearchBar
            onSearch={handleSearch}
            onFilterChange={handleFilterChange}
            functions={availableFunctions}
            groups={availableGroups}
            selectedGroup={selectedGroup}
            selectedFunction={selectedFunction}
          />
        </div>

        {loading ? (
          <div className={styles.loaderContainer}>
            <div
              className={styles.loader}
              style={{ borderColor: colors.primary.lightBlue }}
            />
          </div>
        ) : (
          <div className={styles.grid}>
            {filteredResults.map((product, index) => (
              <ProductCard
                key={index}
                product={product}
                onFavorite={toggleFavorite}
                isFavorite={favorites.some(p => p.name === product.name)}
              />
            ))}
          </div>
        )}

        {favorites.length > 0 && (
          <section className={styles.favoritesSection}>
            <h2
              className={styles.favoritesTitle}
              style={{ color: colors.primary.blue }}
            >
              Soluciones Favoritas
            </h2>
            <div className={styles.grid}>
              {favorites.map((product, index) => (
                <ProductCard
                  key={index}
                  product={product}
                  onFavorite={toggleFavorite}
                  isFavorite={true}
                />
              ))}
            </div>
          </section>
        )}
      </main>
    </div>
  );
}

export default App;
